export default {
    template: `
        <label class="simple-checkbox" :class="{ 'is-disabled': isDisabled }">
            <input type="checkbox" name="AGREEMENT" @change="check" :checked="isChecked">
            <div class="simple-checkbox__icon">
                <svg version="1.1" fill="#fff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" xmlns:xlink="http://www.w3.org/1999/xlink" enable-background="new 0 0 26 26">
                    <path d="m.3,14c-0.2-0.2-0.3-0.5-0.3-0.7s0.1-0.5 0.3-0.7l1.4-1.4c0.4-0.4 1-0.4 1.4,0l.1,.1 5.5,5.9c0.2,0.2 0.5,0.2 0.7,0l13.4-13.9h0.1v-8.88178e-16c0.4-0.4 1-0.4 1.4,0l1.4,1.4c0.4,0.4 0.4,1 0,1.4l0,0-16,16.6c-0.2,0.2-0.4,0.3-0.7,0.3-0.3,0-0.5-0.1-0.7-0.3l-7.8-8.4-.2-.3z"></path>
                </svg></div>
            <div class="simple-checkbox__text">Я согласен на обработку <a href="/include/licenses_detail.php" target="_blank">персональных данных</a></div>
        </label>
    `,
	props: {
        isChecked: {
            type: Boolean,
            default: true
        },
        isDisabled: {
            type: Boolean,
            default: false
        },
        id: {
            type: String,
            default: ""
        },
        url: {
            type: String,
            default: () => window.location.href.split("?")[0]
        },
        sessid: {
            type: String,
            default: "",
        },
        ajaxUrl: {
            type: String,
            default: ""
        }
	},
	data() {
		return {
            agreementSent: false
		}
	},
	components: {
	},
	computed: {
	},
	methods: {
		check(e) {
            this.$emit("consent-checked", e.target.checked);
            if (!this.agreementSent && e.target.checked) {
                this.sendAgreement();
            }
        },
        sendAgreement() {
            $.ajax({
                type: "POST",
                url: this.ajaxUrl,
                dataType: "json",
                data: {
                    ID: this.id,
                    URL: this.url,
                    sessid: this.sessid
                },
                success: (res) => {
                    if (res.success) {
                        this.agreementSent = true;
                    } else {
                        this.$emit("consent-checked", false);
                    }
                }
            });
        }
	},
	mounted() {
	},
	created() {
	}
}

